export type ColorSwatch = { id: string; label: string; value?: string };

// Single source palette — sorted by hex value (ascending)
export const PALETTE: ColorSwatch[] = [
  { id: "black", label: "Black", value: "#000000" },
  { id: "cyan", label: "Cyan", value: "#0891b2" },
  { id: "teal", label: "Teal", value: "#0d9488" },
  { id: "green", label: "Green", value: "#16a34a" },
  { id: "blue", label: "Blue", value: "#2563eb" },
  { id: "brand", label: "Indigo", value: "#4f46e5" },
  { id: "slate", label: "Slate", value: "#64748b" },
  { id: "gray", label: "Gray", value: "#6b7280" },
  { id: "purple", label: "Purple", value: "#7c3aed" },
  { id: "lime", label: "Lime", value: "#84cc16" },
  { id: "magenta", label: "Magenta", value: "#c026d3" },
  { id: "gold", label: "Gold", value: "#ca8a04" },
  { id: "red", label: "Red", value: "#dc2626" },
  { id: "orange", label: "Orange", value: "#ea580c" },
  { id: "yellow", label: "Yellow", value: "#eab308" },
  { id: "pink", label: "Pink", value: "#ec4899" },
  { id: "amber", label: "Amber", value: "#f59e0b" },
  { id: "white", label: "White", value: "#ffffff" },
];

const TAG_IDS = [
  "teal",
  "green",
  "blue",
  "brand",
  "purple",
  "magenta",
  "gold",
  "red",
  "orange",
];

export const TAG_COLORS: ColorSwatch[] = PALETTE.filter((c) =>
  TAG_IDS.includes(c.id),
);
